export default __webpack_public_path__ + "static/N0280-9d14358449660a573ed1b15a4d8e69f3.png";